import React from 'react';

import { DataTable, DataTableRow, Skeleton, DataTableHead } from '@flixbus/honeycomb-react';

const TablePreloader = ({ headers, rowsCount }) => {
	return (
		<DataTable
			headers={
				<DataTableHead>
					{headers.map((header) => (
						<th key={`header-${header}`} scope="col">
							{header}
						</th>
					))}
				</DataTableHead>
			}
		>
			{Array.from({ length: rowsCount }, (_, index) => (
				<DataTableRow key={`row${index}`}>
					{headers.map((header) => (
						<td key={`stab-${header}`}>
							<Skeleton width="lg" height="md" />
						</td>
					))}
				</DataTableRow>
			))}
		</DataTable>
	);
};

export default TablePreloader;
